import React from "react";

const baseCard =
  "w-full h-auto p-2 flex gap-2 items-center rounded-lg bg-customFontMilkWhite dark:bg-custom_dark_primary2 border border-custom_dark_secondary/20 shadow-md";

const MenuItem = ({ title, href, Icon, bgClass = "bg-customWhite", spanClass = "",description="" }) => {
  const containerClass = `${spanClass} ${baseCard}`.trim();

  const handleClick = () => {
    window.location.href = href;
  };

  return (
    <div className={containerClass} onClick={handleClick} role="button">
      <div className="p-1">
      {Icon ? (
        <div className="bg-customLightMilkWhite p-2 rounded-lg"> 
          <Icon size={20} className="text-blue mb-1" />
        </div>
      ) : null}
      </div>
      <div className="flex flex-col">
        <p className="text-sm font-semibold text-customBlack dark:text-customFontMilkWhite">{title}</p>
        <p className="text-xs font-medium text-slate-500 dark:text-customTitleColor">{description}</p>
      </div>
    </div>
  );
};

export default MenuItem;

